interface PermissionResult {
    isActive: boolean
    permissionId: string
}

interface PermissionsResponse {
    results: PermissionResult[]
}

// format user permission
export function formatAccountPermissions(permissionsResponse: PermissionsResponse): string[] {
    return permissionsResponse?.results
        .filter((permission) => permission.isActive)
        .map((permission) => permission.permissionId)
}
